import { createStore } from "redux";

const initialState = {
  utility: {
    loading: false,
    showMsgBox: {
      show: false,
    },
  },
};

function rootReducer(state = initialState, action = {}) {
  switch (action.type) {
    case "utility/setLoading":
      return {
        ...state,
        utility: {
          ...state.utility,
          loading: Boolean(action.payload),
        },
      };
    case "utility/showMsgBox":
      return {
        ...state,
        utility: {
          ...state.utility,
          showMsgBox: {
            ...state.utility.showMsgBox,
            ...(action.payload || {}),
          },
        },
      };
    default:
      return state;
  }
}

const store = createStore(rootReducer);

export const utilityAction = {
  setLoading: (payload) => ({
    type: "utility/setLoading",
    payload,
  }),
  showMsgBox: (payload) => ({
    type: "utility/showMsgBox",
    payload,
  }),
};

export default store;
